import { ComponentType } from 'react';
import OverviewTab from './OverviewTab';
import CommunitiesTab from './CommunitiesTab';
import ClassesAncestriesTab from './ClassesAncestriesTab';
import PrinciplesTab from './PrinciplesTab';
import DistinctionsTab from './DistinctionsTab';
import CampaignTab from './CampaignTab';

export const witherwildContent: Record<string, ComponentType> = {
  'OVERVIEW': OverviewTab,
  'COMMUNITIES': CommunitiesTab,
  'CLASSES & ANCESTRIES': ClassesAncestriesTab,
  'PRINCIPLES': PrinciplesTab,
  'DISTINCTIONS': DistinctionsTab,
  'CAMPAIGN': CampaignTab,
};
